module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-bg"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": _vm.seller.avatar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-top"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.seller.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.seller.name))])]), _vm._v(" "), _c('div', {
    staticClass: "desc-wrap"
  }, [_c('span', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.seller.description))]), _vm._v(" "), _c('span', {
    staticClass: "delivery-time"
  }, [_vm._v("/" + _vm._s(_vm.seller.deliveryTime) + "分钟送达")])]), _vm._v(" "), _c('div', {
    staticClass: "supports-wrap"
  }, [_c('span', {
    staticClass: "icon",
    class: _vm.classMap[_vm.seller.supports[0].type]
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.seller.supports[0].description))])]), _vm._v(" "), _c('div', {
    staticClass: "count-wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDetail($event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.seller.supports.length) + "个")]), _c('span', {
    staticClass: "icon-keyboard_arrow_right"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "header-bulletin",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDetail($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }), _vm._v(" "), _c('span', {
    staticClass: "bulletin"
  }, [_vm._v(_vm._s(_vm.seller.bulletin))]), _vm._v(" "), _c('span', {
    staticClass: "icon-keyboard_arrow_right"
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-detail"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleDetail),
      expression: "toggleDetail"
    }],
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "detail-wrap"
  }, [_c('div', {
    staticClass: "detail-main"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.seller.name))]), _vm._v(" "), _c('div', {
    staticClass: "stars-wrap"
  }, [_c('stars', {
    attrs: {
      "size": 48,
      "score": _vm.seller.score
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "supports-wrap"
  }, [_c('titleline', {
    attrs: {
      "text": "优惠信息"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "supports-list"
  }, _vm._l((_vm.seller.supports), function(item) {
    return _c('li', {
      staticClass: "supports-item"
    }, [_c('span', {
      staticClass: "icon",
      class: _vm.classMap[item.type]
    }), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.description))])])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "bulletin-wrap"
  }, [_c('titleline', {
    attrs: {
      "text": "商家公告"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "bulletin"
  }, [_vm._v(_vm._s(_vm.seller.bulletin))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideDetail($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon-close"
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4411e9e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = 74
// module chunks = 0